// extracted by mini-css-extract-plugin
export default {"welcome":"styles_welcome__mbRZE"};